import { render, staticRenderFns } from "./ShowPurchase.vue?vue&type=template&id=555bb753&"
import script from "./ShowPurchase.vue?vue&type=script&lang=js&"
export * from "./ShowPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports